import React from 'react'
import {
  Container,
  PageHeader,
  PageTitle,
  Subtitle,
  LoadingContainer,
} from './styles'

const SettingsPage = ({ title, subtitle, loading, actions, children }) => {
  if (loading) {
    return (
      <Container>
        <LoadingContainer>Loading {title.toLowerCase()}...</LoadingContainer>
      </Container>
    )
  }

  return (
    <Container>
      <PageHeader>
        <div>
          <PageTitle>{title}</PageTitle>
          {subtitle && <Subtitle>{subtitle}</Subtitle>}
        </div>
        {actions}
      </PageHeader>
      {children}
    </Container>
  )
}

export default SettingsPage
